/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Not_Found_ToastInputs */



/**
* | output |
* | --- |
* | "Media file not found. Please re-import media." |
*
* @param {Load_Project_File_Media_Not_Found_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_not_found_toast = /** @type {((inputs?: Load_Project_File_Media_Not_Found_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Not_Found_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier media introuvable. Veuillez reimporter le media.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mediendatei nicht gefunden. Bitte importieren Sie die Mediendatei erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("File multimediale non trovato. Reimporta il file multimediale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиафайл не найден. Пожалуйста, импортируйте медиафайл повторно.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontró el archivo multimedia. Vuelva a importarlo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到媒体文件。请重新导入媒体文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアファイルが見つかりません。メディアを再インポートしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया फ़ाइल नहीं मिली। कृपया मीडिया को पुनः आयात करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de mídia não encontrado. Por favor, importe a mídia novamente.")
	return /** @type {LocalizedString} */ ("Media file not found. Please re-import media.")
});